'use strict';

import options from '@/assets/js/api/functions';

export default {
    namespaced: true,
    state: {
        merchantClassifications: [],
        merchants: [],
        municipalities: [],
        partners: [],
        provinces: [],
        roles: [],
        rolesStatuses: [],
        userStatuses: []
    },
    getters: {
        getMerchantClassifications: (state) => state.merchantClassifications,
        getMerchants: (state) => state.merchants,
        getMunicipalities: (state) => state.municipalities,
        getPartners: (state) => state.partners,
        getProvinces: (state) => state.provinces,
        getRoles: (state) => state.roles,
        getRoleStatuses: (state) => state.roleStatuses,
        getUserStatuses: (state) => state.userStatuses
    },
    mutations: {
        SET_MERCHANT_CLASSIFICATIONS(state, payload) {
            state.merchantClassifications = payload;
        },
        SET_MERCHANTS(state, payload) {
            state.merchants = payload;
        },
        SET_MUNICIPALITIES(state, payload) {
            state.municipalities = payload;
        },
        SET_PARTNERS(state, payload) {
            state.partners = payload;
        },
        SET_PROVINCES(state, payload) {
            state.provinces = payload;
        },
        SET_ROLES(state, payload) {
            state.roles = payload;
        },
        SET_ROLE_STATUSES(state, payload) {
            state.roleStatuses = payload;
        },
        SET_USER_STATUSES(state, payload) {
            state.userStatuses = payload;
        },
        CLEAR_STATE(state) {
            state.sites = [];
        }
    },
    actions: {
        populateOptions(context, payload) {
            const data = payload.data;
            const options = payload.options || [];

            return new Promise((resolve) => {
                for (var key in data) {
                    if (data[key]) {
                        options.push({ value: data[key], text: key });
                    }
                }
                resolve(options);
            });
        },
        fetchMerchantClassifications(context, payload) {
            let { config } = payload || {};
            // console.log(config);
            return new Promise((resolve, reject) => {
                options
                    .getData({ to: '/options/merchants/classifications', config })
                    .then((response) => {
                        context.commit('SET_MERCHANT_CLASSIFICATIONS', response.data);
                        resolve(response);
                    })
                    .catch((error) => {
                        context.dispatch('error', error, { root: true });
                        reject(error);
                    });
            });
        },
        fetchPartners(context, payload) {
            let { config } = payload || {};
            // console.log(config);
            return new Promise((resolve, reject) => {
                options
                    .getData({ to: '/options/merchants/partners', config })
                    .then((response) => {
                        context.commit('SET_PARTNERS', response.data);
                        resolve(response);
                    })
                    .catch((error) => {
                        context.dispatch('error', error, { root: true });
                        reject(error);
                    });
            });
        },
        fetchMerchants(context, payload) {
            let { config, select } = payload || {};
            return new Promise((resolve, reject) => {
                options
                    .getData({ to: '/options/merchants', config })
                    .then((response) => {
                        const data = response.data;
                        const options = select || [];

                        for (var merchant of Object.values(data)) {
                            let mobileTxt = merchant.mobile ? `[${merchant.mobile}] ` : '';
                            options.push({ value: merchant.uuid, name: merchant.name, text: `${mobileTxt}${merchant.name}`, company: merchant.partner });
                        }

                        response.data = options;
                        context.commit('SET_MERCHANTS', response);
                        resolve(options);
                    })
                    .catch((error) => {
                        context.dispatch('error', error, { root: true });
                        reject(error);
                    });
            });
        },
        fetchMunicipalities(context, payload) {
            let { config } = payload || {};
            // console.log(config);
            return new Promise((resolve, reject) => {
                options
                    .getData({ to: '/options/merchants/municipalities', config })
                    .then((response) => {
                        context.commit('SET_MUNICIPALITIES', response.data);
                        resolve(response);
                    })
                    .catch((error) => {
                        context.dispatch('error', error, { root: true });
                        reject(error);
                    });
            });
        },
        fetchUserStatuses(context, payload) {
            let { config, select } = payload || {};
            return new Promise((resolve, reject) => {
                options
                    .getData({ to: '/options/cms-users/status', config })
                    .then((response) => {
                        context.dispatch('populateOptions', { data: response.data, options: select }).then((options) => {
                            context.commit('SET_USER_STATUSES', options);
                            resolve(options);
                        });
                    })
                    .catch((error) => {
                        context.dispatch('error', error, { root: true });
                        reject(error);
                    });
            });
        },
        fetchProvinces(context, payload) {
            let { config } = payload || {};
            // console.log(config);
            return new Promise((resolve, reject) => {
                options
                    .getData({ to: '/options/merchants/provinces', config })
                    .then((response) => {
                        context.commit('SET_PROVINCES', response.data);
                        resolve(response);
                    })
                    .catch((error) => {
                        context.dispatch('error', error, { root: true });
                        reject(error);
                    });
            });
        },
        fetchRoles(context, payload) {
            let { config, select } = payload || {};
            return new Promise((resolve, reject) => {
                options
                    .getData({ to: '/options/cms-roles', config })
                    .then((response) => {
                        const data = response.data;
                        const options = select || [];

                        for (var role of Object.values(data)) {
                            options.push({ value: role.id, text: role.name });
                        }
                        options.sort((a, b) => a.text.localeCompare(b.text))
                        context.commit('SET_ROLES', options);
                        resolve(options);
                    })
                    .catch((error) => {
                        context.dispatch('error', error, { root: true });
                        reject(error);
                    });
            });
        },
        fetchRoleStatuses(context, payload) {
            let { config, select } = payload || {};
            return new Promise((resolve, reject) => {
                options
                    .getData({ to: '/options/cms-roles/status', config })
                    .then((response) => {
                        context.dispatch('populateOptions', { data: response.data, options: select }).then((options) => {
                            context.commit('SET_ROLE_STATUSES', options);
                            resolve(options);
                        });
                    })
                    .catch((error) => {
                        context.dispatch('error', error, { root: true });
                        reject(error);
                    });
            });
        }
    }
};
